import React, { createContext, PropsWithChildren, useContext, useMemo } from 'react';

import { useIdentity } from '@vp/ubik-context';

type VistaprintAuth = ReturnType<typeof useIdentity>['auth'];

interface IAuthContext {
  isInitialized: boolean;
  authorizationHeader?: string;
  shopperId?: string;
  auth?: VistaprintAuth;
}

const defaultAuthContext: IAuthContext = {
  isInitialized: false,
};

const AuthContext = createContext<IAuthContext>(defaultAuthContext);

export const AuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { auth, isIdentityInitialized } = useIdentity();

  const value = useMemo(
    () => calculateAuthContext(auth, isIdentityInitialized),
    [auth, isIdentityInitialized]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

function calculateAuthContext(auth: VistaprintAuth, isIdentityInitialized: boolean): IAuthContext {
  return {
    isInitialized: isIdentityInitialized,
    authorizationHeader: auth?.getAuthorizationHeader?.(),
    shopperId: auth?.getCanonicalId?.(),
    auth: auth,
  };
}

export const useAuthContext = () => useContext(AuthContext);
